module.exports = __webpack_public_path__ + "static/media/dropdown.19c105f1.svg";